module.exports = __webpack_public_path__ + "VAGRoundedStd-Bold.b681aba54c65f010cf9d.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Bold.woff2
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Bold.woff2
// module chunks = styles